<template>
    <div>
        <header class="header navbar" id="headerNoShow" :class="{ 'navbar--hidden': !showNavbar }">
            <img :src="images.sample" class="logo" alt="">
            <input class="menu-btn" type="checkbox" id="menu-btn" />
            <label class="menu-icon" for="menu-btn">
                <span class="navicon"></span>
            </label>
            <ul class="menu" id="menu">
                <!--    <li><router-link to="/forsynadd" class="btn">Skapa försyn</router-link></li>-->
                <li v-if="!user"><router-link to="/forsyn-list" class="btn">Hälsö</router-link></li>
                <li><router-link to="/calendar" class="btn">Kalender</router-link></li>
                <li><router-link to="/map" class="btn">Karta</router-link></li>
                <li><router-link to="/about" class="btn">Om företaget</router-link></li>
                <li>
                    <button class="btn logout" @click="signOut()">Logga ut</button>
                </li>
            </ul>
        </header>
    </div>
</template>

<script>
    import firebase from "firebase";

    export default {
        name: 'Header',
        components: {
        },
        data() {
            return {
                showNavbar: true,
                lastScrollPosition: 0,
                images: {
                    sample: require('../assets/logo.png')
                }
            }
        },
        computed: {
            user() {
                return this.$store.getters.getUser;
            }
        },

        mounted () {
            window.addEventListener('scroll', this.onScroll)
        },

        beforeDestroy () {  /* Navbar försvinner vid scroll */
            window.removeEventListener('scroll', this.onScroll)
        },

        methods: {
            /*  async logout() {      // Fungerar också. Ett annat sätt att skriva logout på.
                    await firebase.auth().signOut().then(function () {
                        console.log('Signed Out');  });
                    await this.$router.replace('/')
                },*/

            signOut: function () {
                firebase.auth()
                    .signOut()
                    .then(() => {
                        console.log('Signed Out');
                        this.$router.replace('/');
                    });
            },
            //https://medium.com/@Taha_Shashtari/hide-navbar-on-scroll-down-in-vue-fb85acbdddfe
            onScroll() {
                // Get the current scroll position
                const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop;
                // Because of momentum scrolling on mobiles, we shouldn't continue if it is less than zero
                if (currentScrollPosition < 0) {
                    return
                }
                // Stop executing this function if the difference between
                // current scroll position and last scroll position is less than some offset
                if (Math.abs(currentScrollPosition - this.lastScrollPosition) < 60) {
                    return
                }
                // Here we determine whether we need to show or hide the navbar
                this.showNavbar = currentScrollPosition < this.lastScrollPosition;
                // Set the current scroll position as the last scroll position
                this.lastScrollPosition = currentScrollPosition
            },
        },

    }
</script>

<style scoped lang="scss">
    /*  Navigering */
    .router-link{
        text-decoration: none;
        cursor: pointer;
    }

    /* Meny Navigation */
    .navbar {
        padding: 10px 15px 0 0;
    }

    .navbar.navbar--hidden {
        box-shadow: none;
        transform: translate3d(0, -100%, 0);
    }

    .header {
        background-color: #fff;
        position: fixed;
        /*    width: 100%;*/
        width: 100vw;
        z-index: 3;
        top: 0;
        max-height: 90px;
        box-shadow: 0 0 5px rgba(120, 120, 120, 0.5);
        transform: translate3d(0, 0, 0);
        transition: 0.1s all ease-out;
    }

    .header ul {
        margin: 0;
        padding: 0;
        list-style: none;
        overflow: hidden;
        background-color: #fff;
    }

    .header li a, .logout {
        display: flex;
        justify-content: center;
        padding: 10px 10px;
        text-decoration: none;
        font-size: 12pt;
    }

    /* Logout is a button */
    header li button {
        color: #333;
        font-size: 12pt;
        border: 1px solid transparent;
    }

    .header li a:hover,
    .header li a:focus,
    .header li a:active,
    .header .menu-btn:hover,
    .buttons:hover,
    .buttons:focus,
    .btn.focus, .btn:focus,
    .buttons:active {
        /*    outline: #ddd thin dotted;*/
        outline: none;
        box-shadow: none;
    }
    .header .logo {
        display: block;
        float: left;
        padding: 0;
        max-height: 70px;
        margin-left: 5px;
    }

    /*  https://codepen.io/mutedblues/pen/MmPNPG*/
    /* menu */
    .header .menu {
        clear: both;
        max-height: 0;
    }

    /* menu icon */
    .header .menu-icon {
        cursor: pointer;
        display: inline-block;
        float: right;
        padding: 28px 20px;
        position: relative;
        user-select: none;
    }

    .header .menu-icon .navicon {
        background: #333;
        display: block;
        height: 2px;
        position: relative;
        transition: background .2s ease-out;
        width: 18px;
    }

    .header .menu-icon .navicon:before,
    .header .menu-icon .navicon:after {
        background: #333;
        content: '';
        display: block;
        height: 100%;
        position: absolute;
        transition: all .2s ease-out;
        width: 100%;
    }

    .header .menu-icon .navicon:before {
        top: 5px;
    }

    .header .menu-icon .navicon:after {
        top: -5px;
    }

    /* menu btn */
    .header .menu-btn {
        display: none;
    }

    .header .menu-btn:checked ~ .menu {
        max-height: 240px;
    }

    .header .menu-btn:checked ~ .menu-icon .navicon {
        background: transparent;
    }

    .header .menu-btn:checked ~ .menu-icon .navicon:before {
        transform: rotate(-45deg);
    }

    .header .menu-btn:checked ~ .menu-icon .navicon:after {
        transform: rotate(45deg);
    }

    .header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:before,
    .header .menu-btn:checked ~ .menu-icon:not(.steps) .navicon:after {
        top: 0;
    }

    /* 48em = 768px */
    @media (min-width: 48em) {
        .header li {
            float: left;
        }
        .header li a {
            padding: 10px 20px;
        }
        .header .menu {
            clear: none;
            float: right;
            max-height: none;
        }
        .header .menu-icon {
            display: none;
        }
    }
    /* Hamburgerer */
    @media only screen and (max-width: 815px) {
        .navbar {
            display: inline-block;
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/Header.vue